import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import * as PlanType from 'ecosystem-marketplace-core/constants/pricings/PlanType';
import FilterToggleGroup from 'ecosystem-marketplace-core/filters/components/filterToggleGroup';
// @ts-expect-error module is untyped
import { getPlanTypeFilterI18nKey } from '../../../../utils/i18n';
const ALL_PLAN_TYPES_VALUE = 'all';
const pricings = [ALL_PLAN_TYPES_VALUE, PlanType.FREE, PlanType.MONTHLY, PlanType.YEARLY, PlanType.ONE_TIME, PlanType.METERED, PlanType.CONTACT_US];

function getPricingText(value) {
  const key = value === ALL_PLAN_TYPES_VALUE ? 'appMarketplace.storefront.filters.planType.items.all' : getPlanTypeFilterI18nKey(value);
  return unescapedText(key);
}

function getOptions() {
  return pricings.map(price => {
    return {
      text: getPricingText(price),
      value: price
    };
  });
}

const PriceFilter = ({
  disabled,
  onChange,
  value
}) => {
  const options = useMemo(() => getOptions(), []);

  const handleChange = event => {
    const eventValue = event.target.value;
    const newValue = eventValue === ALL_PLAN_TYPES_VALUE ? null : eventValue;
    const newEvent = SyntheticEvent(newValue, event);
    onChange(newEvent);
  };

  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.planType.titleText'),
    disabled: disabled,
    name: "price",
    onChange: handleChange,
    options: options,
    value: value || ALL_PLAN_TYPES_VALUE
  });
};

export default PriceFilter;